<section class="help-center py-3">
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <div class="logo">
                    <img src="assets/images/logo.png" alt="logo" class="logo" />
                  </div>
            </div>
            <div class="col-md-6">
                <div class="text-end help-logout">
                    <a href="#">Go back to home</a>
                </div>
            </div>
        </div>

        <!--- Help Center Header --->
        <div class="help-center-header my-5 text-center">
            <h3>Help Center</h3>
            <p>We understand that sometimes you may encounter difficulties or have questions while using our platform, and we're here to assist you every step of the way</p>
        </div>

        <!--- help center cards --->
        <div class="row">
            <div class="col-md-3">
                <div class="help-card">
                    <img src="assets/images/help/start.png" alt="logo" />
                    <h5>Getting Started</h5>
                    <p>Everything you need to know to get Started and get to work in <span class="col1 fw-bold">QMigrator</span></p>
                </div>
            </div>
            <div class="col-md-3">
                <div class="help-card">
                    <img src="assets/images/help/150.svg" alt="logo" />
                    <h5>Server Setup</h5>
                    <p>Connect, Simplify, and automate. Discover the power of <span class="col1 fw-bold">QMigrator Application</span></p>
                </div>
            </div>
            <div class="col-md-3">
                <div class="help-card">
                    <img src="assets/images/help/user.png" alt="logo" />
                    <h5>Account Setup</h5>
                    <p>Adjust your profile and preferences to make <span class="col1 fw-bold">QMigrator</span> work just for you </p>
                </div>
            </div>
            <div class="col-md-3">
                <div class="help-card">
                    <img src="assets/images/help/154.svg" alt="logo" />
                    <h5>Trust & Safety </h5>
                    <p>Trust on our current Application and learn how we migrate your data</p>
                </div>
            </div>
        </div>

        <!--- Help center Data --->
        <div class="helpCenter_desc mt-4">
            <div class="row">
                <div class="col-auto col-md-3 col-xl-3 sideNav helpNav">
                    <nav class="navbar navbar-vertical navbar-expand-xl">
                        <div class="collapse navbar-collapse w-100" id="navbarVerticalCollapse">
                          <div class="navbar-vertical-content w-100">
                            <ul class="navbar-nav flex-column w-100" id="navbarVerticalNav">               
                                <li class="nav-item">
                                    <!-- parent pages-->
                                    <div class="nav-item-wrapper">
                                        <a class="nav-link active dropdown-toggle" href="#nv-home" data-bs-toggle="collapse">
                                        <div class="d-flex align-items-center">
                                          <span class="ms-1">Getting Started</span>
                                        </div>
                                      </a>
                                      <div class="parent-wrapper label-1">
                                        <ul class="nav collapse parent" data-bs-parent="#navbarVerticalCollapse" id="nv-home">
                                          <li class="nav-item"><a class="nav-link" href="#">
                                              <div class="d-flex align-items-center"><span class="nav-link-text">Account Creation</span></div>
                                            </a><!-- more inner pages-->
                                          </li>
                                          <li class="nav-item"><a class="nav-link" href="#">
                                              <div class="d-flex align-items-center"><span class="nav-link-text">Platform Navigation</span></div>
                                            </a><!-- more inner pages-->
                                          </li>
                                          <li class="nav-item"><a class="nav-link" href="#">
                                              <div class="d-flex align-items-center"><span class="nav-link-text">User Settings</span></div>
                                            </a><!-- more inner pages-->
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" href="#">
                                        <span class="ms-1">Account setup and Management</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" href="#">
                                        <span class="ms-1">Troubleshooting & Technical support</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" href="#">
                                        <span class="ms-1">Billing and payment</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" href="#">
                                        <span class="ms-1">Frequently asked questions</span>
                                    </a>
                                </li>
                            </ul>
                          </div>
                        </div>
                      </nav>
                </div>
                <div class="col-xl-9">
                    <div class="help-center-description">
                        <h3>Getting Started</h3>
                        <p>Welcome to <span class="col1 fw-bold">QMigrator</span>! This guide will help you get started and make the most out of our services.</p>
                        <p>Most of services</p>
                        <h4 class="main_h">1. Account Creation</h4>
                        <ul>
                            <li>Visit our website and click on the "sign up" or "create account" button</li>
                            <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda rem voluptas voluptates voluptate corporis? Expedita, nihil accusantium earum voluptatum ut facere fugit porro velit? Cupiditate dignissimos iure excepturi necessitatibus velit.</li>
                            <li>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eum dolores quam totam omnis pariatur ea maxime, aspernatur minus nulla reprehenderit, facilis aperiam, veniam iste culpa? Et ipsum incidunt laudantium quam.</li>
                            <li>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum laudantium dolore officiis excepturi eum et eaque qui aliquid autem perspiciatis accusamus vel esse possimus facere vitae, quia alias est a.</li>
                        </ul>
                        <h4 class="main_h">2. Platform Navigation</h4>
                        <ul>
                            <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure hic, tempore est unde blanditiis dolor ipsam mollitia quasi maxime neque aspernatur dignissimos minus assumenda quisquam odio officia provident id quo.</li>
                            <li>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sapiente saepe voluptate blanditiis error temporibus placeat corrupti repellendus, suscipit mollitia omnis quaerat nihil numquam voluptatem doloribus nobis laborum assumenda, ipsam doloremque?</li>
                            <li>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptatem dicta commodi, architecto earum amet eligendi odio atque repellat vel neque vitae recusandae consequuntur, velit quas laborum minus adipisci quam debitis.</li>
                            <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi ducimus alias vitae aliquam accusamus consequuntur dolorum possimus ea doloremque? Dolore incidunt consequuntur aut laboriosam minima itaque voluptatibus praesentium recusandae alias?</li>
                        </ul>
                        <h4 class="main_h">3. Account Setup</h4>
                        <ul>
                            <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Expedita, ducimus officiis quisquam facere, quo rem voluptates molestiae natus sit ipsum laboriosam at laudantium aperiam deleniti illum recusandae modi accusantium impedit.</li>
                            <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dignissimos facere mollitia laboriosam error exercitationem tenetur eveniet? Adipisci voluptates distinctio repellat quod nisi, eum accusantium dolorem, explicabo, culpa voluptatem alias dolores.</li>
                            <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Possimus similique odio nesciunt necessitatibus optio accusantium illo quidem dignissimos dicta cupiditate qui totam, repellendus adipisci itaque nisi tempore, iure provident ab!</li>
                        </ul>
                        <h4 class="main_h">4. Connecting with others</h4>
                        <ul>
                            <li>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Mollitia ipsa accusamus aut placeat dolores, architecto explicabo? Vero qui suscipit nemo corporis eaque possimus, aspernatur fugit commodi repellat, quae tenetur autem.</li>
                            <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Obcaecati doloremque omnis blanditiis voluptatem eveniet inventore, quas corrupti quod. Sint voluptatem incidunt earum maxime quia ea commodi praesentium totam vel a!</li>
                        </ul>
                        <h4 class="main_h">5. Accessing Help and Support </h4>
                        <ul>
                            <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos tempora quo iure vitae dolorum facere maiores? Placeat exercitationem mollitia, nisi voluptas veritatis voluptatum voluptatem minus alias id modi libero doloribus.</li>
                            <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deleniti illo vero atque amet unde quibusdam quisquam laborum. Accusantium eius dolor animi repellendus corrupti tenetur, dolores veniam sapiente labore in a.</li>
                            <li>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Laborum, repellendus accusantium harum sapiente quod fugit autem temporibus fuga reiciendis placeat exercitationem aspernatur unde dolore deserunt cum quo culpa, ratione amet.</li>
                            <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique totam minus eaque ipsam tempore minima laudantium recusandae nihil, dignissimos autem quas error nam, possimus rem saepe voluptatum ullam commodi facere.</li>
                        </ul>
                        <h4 class="main_h">6. Getting Started</h4>
                        <ul>
                            <li>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dignissimos ut sit iusto quod aut eveniet itaque aliquid accusamus. Quam pariatur corporis assumenda nihil minus eaque, ad ea sequi suscipit et.</li>
                            <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt tempore facere placeat qui ipsa culpa nesciunt voluptatibus incidunt nemo corporis, ab iusto. Consequatur saepe quis asperiores tempora quia dolore perferendis.</li>
                            <li>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Odio nemo at aperiam sint. Modi iusto voluptatum laborum aperiam consectetur earum, repellendus, suscipit commodi explicabo, nobis velit saepe quaerat molestias ipsam.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>